import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DataSharingService {

    private showCustomerDetailSubject = new Subject<boolean>();
    private showLoaderSubject = new Subject<boolean>();
    private messageSource = new Subject();
    currentMessage = this.messageSource.asObservable();
    public currentPage: string = '';
    public IsContractUpgraded: boolean = false;
    
    changeMessage(data:string) {
        this.messageSource.next(data);
    }

    setShowCustomerDetail(show: boolean) {
        this.showCustomerDetailSubject.next(show);
    }
    
    getShowCustomerDetail(): Observable<boolean> {
        return this.showCustomerDetailSubject.asObservable();
    }

    setShowLoader(show: boolean) {
        this.showLoaderSubject.next(show);
    }

    getShowLoader(): Observable<boolean> {
        return this.showLoaderSubject.asObservable();
    }

    isMobile(){
        // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //     return true;
        // } else {
        //     return false;
        // }
        if (window.matchMedia("(max-width: 767px)").matches) {
          return true;
        } else {
          return false;
        }

    }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/services/data-sharing.service.ts